
import { useLocalization } from '@progress/kendo-react-intl';
import { enMessages } from "../../../../messages/en-US";

import { Button } from '@progress/kendo-react-buttons';

interface Props {
  daysSelected: any;
  setDaysSelected: any;
}

function DayPickerWeek2(props: Props) {
  const addDay = (day: number) => {
    if(props.daysSelected.length === 0) {
      props.setDaysSelected([day]);
    } else {
      props.setDaysSelected([]);
      props.setDaysSelected([day]);
    }
  };

  const localizationService = useLocalization();

  return (
    <div className="grid grid-cols-7 gap-x-3  py-2 ">
      <Button
        onClick={() => addDay(0)}
        selected={props.daysSelected.includes(0)}
        togglable={true}
        type="button"
      >
        {localizationService.toLanguageString('custom.sunday', enMessages.custom.sunday)}
      </Button>
      <Button
        onClick={() => addDay(1)}
        selected={props.daysSelected.includes(1)}
        togglable={true}
        type="button"
      >
        {localizationService.toLanguageString('custom.monday', enMessages.custom.monday)}
      </Button>
      <Button
        onClick={() => addDay(2)}
        selected={props.daysSelected.includes(2)}
        togglable={true}
        type="button"
      >
        {localizationService.toLanguageString('custom.tuesday', enMessages.custom.tuesday)}
      </Button>
      <Button
        onClick={() => addDay(3)}
        selected={props.daysSelected.includes(3)}
        togglable={true}
        type="button"
      >
        {localizationService.toLanguageString('custom.wednesday', enMessages.custom.wednesday)}
      </Button>
      <Button
        onClick={() => addDay(4)}
        selected={props.daysSelected.includes(4)}
        togglable={true}
        type="button"
      >
        {localizationService.toLanguageString('custom.thursday', enMessages.custom.thursday)}
      </Button>
      <Button
        onClick={() => addDay(5)}
        selected={props.daysSelected.includes(5)}
        togglable={true}
        type="button"
      >
        {localizationService.toLanguageString('custom.friday', enMessages.custom.friday)}
      </Button>
      <Button
        onClick={() => addDay(6)}
        selected={props.daysSelected.includes(6)}
        togglable={true}
        type="button"
      >
        {localizationService.toLanguageString('custom.saturday', enMessages.custom.saturday)}
      </Button>
    </div>
  );
}

export default DayPickerWeek2;
